import { Modal, Header, ModalContent, Section, Benefit, Footer } from './styles'
import CloseButton from 'src/global/CloseButton'
import { Backdrop, GlassButton } from 'src/global'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUtensils, faCalendarCheck, faLeaf, faBan, faImage, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons'
import { MAX_FREE_RETOUCHES } from '@meniudigital/shared'

type Props = {
  isOpen: boolean
  onClose: () => void
  onPurchase: () => void
}

// Each feature gets its own tile colour, light to dark, like the iOS settings list
const BENEFITS = [
  {
    icon: faUtensils,
    accent: ['#ffb347', '#ff7a1a'],
    title: 'Produse nelimitate',
    description: 'Adaugi oricâte produse în meniu. În varianta de test ești limitat la 30 de produse.',
  },
  {
    icon: faWandMagicSparkles,
    accent: ['#ff8ad4', '#c026d3'],
    title: 'Retușări automate nelimitate',
    description: `Fiecare poză încărcată este procesată automat: expunere, contrast și culori corectate. Limita gratuită este de ${MAX_FREE_RETOUCHES} retușări.`,
  },
  {
    icon: faLeaf,
    accent: ['#4fe3c1', '#0fa38a'],
    title: 'Declarații nutriționale nelimitate',
    description: 'Generezi automat declarația nutrițională pentru oricâte produse. Limita gratuită este de 15 generări.',
  },
  {
    icon: faBan,
    accent: ['#ff7b8a', '#e0245e'],
    title: 'Fără reclame pe meniu',
    description: 'Meniul tău rămâne curat, fără reclame. În varianta de test, reclamele apar după 30 de zile de la înregistrare.',
  },
  {
    icon: faImage,
    accent: ['#b79cff', '#7c3aed'],
    title: 'Poze la rezoluție maximă',
    description: 'Pozele produselor sunt afișate la calitate maximă, fără compresie suplimentară.',
  },
  {
    icon: faCalendarCheck,
    accent: ['#5ee07a', '#22a54a'],
    title: 'Rezervări online nelimitate',
    description: 'Primești oricâte rezervări direct prin meniu. Limita gratuită este de 3 rezervări.',
  },
]

export default function SubscriptionInfoModal({ isOpen, onClose, onPurchase }: Props) {
  return (
    <>
      <Backdrop onClick={onClose} className={isOpen ? 'open' : 'closed'} />
      <Modal className={isOpen ? 'open' : 'closed'}>
        <Header>
          <div className="title-wrapper">
            <div className="title">Ce include abonamentul MeniuDigital.ro?</div>
          </div>
          <CloseButton onClick={onClose} title="Închide" color="#ffffff" style={{ marginTop: '-16px', marginRight: '-9px' }} />
        </Header>
        <ModalContent>
          <Section className="intro">
            <p>Abonamentul MeniuDigital deblochează toate funcțiile de mai jos și elimină limitele din varianta de test.</p>
          </Section>

          <Section>
            {BENEFITS.map(benefit => (
              <Benefit key={benefit.title} $accent={benefit.accent[0]} $accentDark={benefit.accent[1]}>
                <div className="icon">
                  <FontAwesomeIcon icon={benefit.icon} />
                </div>
                <div className="content">
                  <div className="benefit-title">{benefit.title}</div>
                  <div className="benefit-description">{benefit.description}</div>
                </div>
              </Benefit>
            ))}
          </Section>

          <Section className="pricing">
            <h3>Prețuri</h3>
            <div className="plans">
              <div className="plan">
                <div className="plan-duration">6 luni</div>
                <div className="plan-price">550 RON</div>
                <div className="plan-equivalent">~91 RON / lună</div>
              </div>
              <div className="plan">
                <div className="plan-duration">12 luni</div>
                <div className="plan-price">1000 RON</div>
                <div className="plan-equivalent">~83 RON / lună</div>
              </div>
            </div>
          </Section>

          <Section className="how-to">
            <h3>Cum achiziționezi</h3>
            <p>Alegi varianta dorită mai jos și finalizezi achiziția în câțiva pași.</p>
            <p>Plata se face online cu cardul sau prin transfer bancar, pe firmă sau persoană fizică.</p>
          </Section>
        </ModalContent>
        <Footer>
          <GlassButton onClick={onPurchase}>Achiziționează abonament</GlassButton>
        </Footer>
      </Modal>
    </>
  )
}
